var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ip-consent"},[_c('div',{staticClass:"text"},[_vm._v(" "+_vm._s(_vm.localization.ip_warning)+" ")]),_c('div',{staticClass:"close-btn",on:{"click":_vm.closeWarning}},[_vm._v(" ✖ ")])])}
var staticRenderFns = []

export { render, staticRenderFns }